module.exports = __webpack_public_path__ + "img/logo.0ca7c214.png";